export class PayRateHistoryDto {
  public id: string;
  public dateModified: string;
  public modifiedBy: string;
  public payRate: number;
}
